import React from "react"
import {
  InputContainer,
  LabelRow,
  Label,
  InputWithLabel,
  FormRow,
} from "./common"
import { Required } from "buoy-input"
import { Dropdown } from "buoy-core"
import { options } from "../userDetailsUtilities"
import { responsive } from "../../../common/styledHelpers"
// 4851-todo: update responsive helper

const Address = ({
  dirty,
  edit,
  selected,
  payForm,
  address1,
  address2,
  locality,
  admin_level1,
  postal_code,
  onFocus,
  onBlur,
  onChangeInput,
  onChangeDropdown,
}) => (
  <React.Fragment>
    <InputWithLabel
      isEditing={dirty}
      edit={edit}
      onFocus={onFocus("address1")}
      onBlur={onBlur("address1")}
      showError={address1.edited && !address1.valid && !address1.isActive}
      error={address1.error}
      label="Address"
      onChange={onChangeInput("address1")}
      value={
        address1.edited
          ? address1.value
          : selected.address1 || selected.address1
      }
      required
    />
    <InputWithLabel
      isEditing={dirty}
      edit={edit}
      onFocus={onFocus("address2")}
      onBlur={onBlur("address2")}
      showError={address2.edited && !address2.valid && !address2.isActive}
      label="Address 2"
      onChange={onChangeInput("address2")}
      value={
        address2.edited
          ? address2.value
          : selected.address2 || selected.address2
      }
    />
    <FormRow isEditing={dirty}>
      <InputWithLabel
        isEditing={dirty}
        edit={edit}
        onFocus={onFocus("locality")}
        onBlur={onBlur("locality")}
        showError={locality.edited && !locality.valid && !locality.isActive}
        error={locality.error}
        label="City"
        onChange={onChangeInput("locality")}
        value={
          locality.edited
            ? locality.value
            : selected.locality || selected.locality
        }
        required
      />
      <InputContainer
        paddingBottom={
          dirty
            ? "padding-bottom: 24px"
            : responsive("padding-bottom", "24px", "20px")
        }
      >
        <LabelRow>
          <Label>
            State<Required />
          </Label>
        </LabelRow>
        <Dropdown
          noMargin
          options={options.state}
          placeholder="State"
          showError={payForm && !admin_level1.valid}
          error={admin_level1.error}
          value={admin_level1.value}
          onChange={onChangeDropdown("admin_level1")}
        />
      </InputContainer>
      <InputWithLabel
        isEditing={dirty}
        edit={edit}
        onFocus={onFocus("postal_code")}
        onBlur={onBlur("postal_code")}
        showError={
          postal_code.edited && !postal_code.valid && !postal_code.isActive
        }
        error={postal_code.error}
        label="Zip"
        onChange={onChangeInput("postal_code")}
        value={postal_code.edited ? postal_code.value : selected.postal_code}
        required
      />
    </FormRow>
  </React.Fragment>
)

export { Address as default }



// WEBPACK FOOTER //
// ./assets/account/components/forms/Address.js